import React from 'react';

export const SkeletonGrid: React.FC<{ count?: number }> = ({ count = 6 }) => (
  <div className="skeleton-grid" aria-hidden="true">
    {Array.from({ length: count }, (_, i) => (
      <div key={i} className="skeleton skeleton-card" />
    ))}
  </div>
);

export const SkeletonDetail: React.FC = () => (
  <div className="skeleton-detail" aria-hidden="true">
    <div className="skeleton skeleton-detail-media" />
    <div className="skeleton-lines">
      <div className="skeleton skeleton-line title" />
      <div className="skeleton skeleton-line" />
      <div className="skeleton skeleton-line" />
      <div className="skeleton skeleton-line short" />
    </div>
  </div>
);
